export class Filter {

    id: number;
    name: string
    values: Array<string>

    static createFromObj(obj: Object): Filter {
        const filter = new Filter(obj.id, obj.name);
        filter.values = obj.values;
        return filter;
    }

    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

}